import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { API_URL } from '@core/config/api-url.token';
import { API_ENDPOINTS } from '@shared/constants/api-endpoints.const';
import { Observable } from 'rxjs';
import { AccessRequestInput } from '../../../domain/models/access-request.model';
import { AccessRequestRequestDto } from '../../dtos/access-request-request.dto';

@Injectable()
export class AccessRequestRemoteDatasource {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = inject(API_URL);

  public submit(input: AccessRequestInput): Observable<void> {
    const request: AccessRequestRequestDto = {
      Name: input.name,
      Email: input.email,
      ClinicName: input.clinicName,
      Phone: input.phone,
      Message: input.message,
    };
    return this.http.post<void>(`${this.apiUrl}${API_ENDPOINTS.accessRequests.submit}`, request);
  }
}
